module.exports = __webpack_public_path__ + "img/noJobsIcon.3f070d66.svg";